export default {
  PREPARING: {
    label: 'Em preparação',
    class: 'has-text-grey',
    icon: 'sync-alt',
    value: 'PREPARING',
  },
  PROCESSING: {
    label: 'Processando',
    class: 'has-text-grey',
    icon: 'sync-alt',
    value: 'PROCESSING',
  },
  SUCCESS: {
    label: 'Sucesso',
    class: 'has-text-primary',
    icon: 'check',
    value: 'SUCCESS',
  },
  ERROR: {
    label: 'Erro',
    class: 'has-text-danger',
    icon: 'exclamation-triangle',
    value: 'ERROR',
  },
  TO_BE_PROCESSED: {
    label: 'Preparando para processar',
    class: 'has-text-grey',
    icon: 'sync-alt',
    value: 'TO_BE_PROCESSED',
  },
  WAITING_IN_QUEUE: {
    label: 'Aguardando',
    class: 'has-text-grey',
    icon: 'sync-alt',
    value: 'WAITING_IN_QUEUE',
  },
  WAITING_LOGISTIC_PROVIDER: {
    label: 'Aguardando transportadora',
    class: 'has-text-grey',
    icon: 'sync-alt',
    value: 'WAITING_LOGISTIC_PROVIDER',
  },
  SCHEDULED: {
    label: 'Pré lista de postagem agendada',
    class: 'has-text-grey',
    icon: 'sync-alt',
    value: 'SCHEDULED',
  },
  UNAVAILABLE_LOGISTIC_PROVIDER: {
    label: 'Erro na transportadora',
    class: 'has-text-danger',
    icon: 'exclamation-triangle',
    value: 'UNAVAILABLE_LOGISTIC_PROVIDER',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-psl/features/list/enums/localizedStatus.enum.js